export const experienceData = [
    {
        id: 1,
        company: 'APCFSS',
        jobtitle: 'Backend Developer',
        startYear: '2023',
        endYear: '2025'
    },
    {
        id: 2,
        company: 'APCFSS',
        jobtitle: 'Frontend Developer',
        startYear: '2023',
        endYear: '2025'
    },
    // {
    //     id: 3,
    //     company: 'Wonka Industries',
    //     jobtitle: 'Marketing',
    //     startYear: '2020',
    //     endYear: 'Present'
    // },
]